<template>
  <v-dialog
    v-model="showDialog"
    max-width="500"
    persistent
    @click:outside="handleCancel"
  >
    <v-card dark>
      <v-card-title class="headline">
        <v-icon class="mr-2" color="primary">mdi-bell-outline</v-icon>
        Enable Push Notifications
      </v-card-title>

      <v-card-text class="pt-4">
        <p class="mb-4">
          Get instant notifications about auditions, reminders, and important updates even when the app is closed.
        </p>
        <v-alert
          type="info"
          outlined
          dense
          class="mb-4"
        >
          <small>
            <strong>Note:</strong> You'll be asked to allow notifications in your browser. 
            Make sure to click "Allow" to receive push notifications.
          </small>
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="handleCancel"
        >
          Not Now
        </v-btn>
        <v-btn
          color="primary"
          @click="handleEnable"
          :loading="loading"
        >
          Enable Notifications
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'NotificationPermission',
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters('notifications', ['showPermissionDialog']),
    showDialog: {
      get() {
        return this.showPermissionDialog;
      },
      set(value) {
        if (!value) {
          this.hidePermissionDialog();
        }
      }
    }
  },
  methods: {
    ...mapActions('notifications', [
      'subscribeToPushNotifications',
      'hidePermissionDialog'
    ]),
    async handleEnable() {
      this.loading = true;
      try {
        await this.subscribeToPushNotifications();
      } catch (error) {
        // Error is already handled in the action
      } finally {
        this.loading = false;
      }
    },
    handleCancel() {
      this.hidePermissionDialog();
    }
  }
};
</script>

<style scoped>
</style>
